const config = {
    carouselFirst: "https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/backgroundImage.png",
    carouselSecond: "https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/backGroundTwo.png",
    carouselThird: "https://osstest.sayfamily.cn/zuji-web/images/banner/image4.jpg",
    lightLogo: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/GroupBlue.svg',
    darkLogo: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/GroupLight.svg',
    privacyPolicyUrl: 'https://oss.sayfamily.com/agreement/Privacy-Agreement.html',
    userInfoUrl: 'https://oss.sayfamily.com/agreement/Software-Agreement.html',
    introImages: [
        'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E4%BA%BA%E7%94%9F%E7%BB%8F%E5%8E%86%E5%88%97%E8%A1%A81080_1920.png',
        'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E5%AE%B6%E8%B0%B11080_1920.png',
        'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E5%BB%B6%E6%97%B6%E6%B6%88%E6%81%AF1080_1920.png',
        'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E7%A5%88%E6%84%BF%E6%A0%911080_1920.png',
        'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E4%BA%BA%E7%94%9F%E7%BB%8F%E5%8E%86%E8%AF%A6%E6%83%851080_1920.png',

    ],
    teamPhotos: {
        '王威': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/wangwei.jpg',
        '刘一帆': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/liuyifan.jpg',
        '许鹏晖': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/xupenghui.jpg',
        '李扬': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/liyang.jpg',
        '刘安琪': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/liuanqi.jpg',
        '黄建': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/huangjian.jpg',
        '程勇辉': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/chengyonghui.jpg',
        '刘成': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/liucheng.png',
        '陈君': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/chenjun.jpg',
        '贺湘': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/hexiangnew.jpg',
        '涂振武': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/tuzhenwu.jpg',
        '朱俊飞': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/zhujunfei.jpg',
        '姚丽婷': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/yaoliting.jpg',
        '彭永乐': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/pengyongle.jpg',
        '余光辉': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/yuguanghui.jpg',
        '岳万林': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/yuewanlin.jpg',
        '涂招娣': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/tuzhaodi.jpg',
        '李佩蓉': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/lipeirong.jpg',
        '张敏': 'https://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/zhangmin.jpg',
    },
    // 族语APP 介绍页：横图 + 六大功能配图（可直接替换 OSS 地址）
    appPage: {
        featureBanner: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/annouceImg.png',
        features: [
            {
                id: '01',
                title: '智能家谱',
                subtitle: '让家庭关系清晰可见',
                image: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E5%BB%B6%E6%97%B6%E6%B6%88%E6%81%AF1080_1920.png',
                paragraphs: [
                    '传统家谱更多记录血缘关系，而现代家庭需要的是更丰富、更适合数字时代的家庭档案。',
                    '族语智能家谱通过可视化编辑、智能合并与多谱系管理，极简操作构建庞大亲缘网络，帮助用户建立家庭成员关系，让父母、孩子、祖辈之间形成清晰连接。家庭成员可以共同完善信息，让每个人都参与到家庭记忆的建设中。它不仅是一张关系图，更是一份记录家庭传承的数字档案。',
                ],
            },
            {
                id: '02',
                title: '成长动态',
                subtitle: '记录孩子成长轨迹',
                image: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E4%BA%BA%E7%94%9F%E7%BB%8F%E5%8E%86%E5%88%97%E8%A1%A81080_1920.png',
                paragraphs: [
                    '对于父母来说，孩子成长过程中的每一个阶段都值得珍藏。很多家长都会拍摄大量照片和视频，但随着时间推移，记录往往变得杂乱。',
                    '族语成长动态，直系家人可以实时共览，也可以同步上传，且成长动态的记录时间支持自定义，还原真实成长轨迹。孩子长大后，认证即可自动同步账号。帮助家庭整理孩子成长过程，将碎片化的照片、视频和文字记录串联起来，让成长轨迹更加完整。',
                    '多年以后，孩子可以回看自己的成长故事，了解家人陪伴自己的点点滴滴。',
                ],
            },
            {
                id: '03',
                title: '日常动态',
                subtitle: '保存平凡生活里的珍贵瞬间',
                image: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E4%BA%BA%E7%94%9F%E7%BB%8F%E5%8E%86%E8%AF%A6%E6%83%851080_1920.png',
                paragraphs: [
                    '人生的重要记忆，并不只发生在特殊日子。',
                    '一次家庭晚餐、一段聊天、一张照片，都是生活的一部分。族语日常动态帮助用户记录真实生活，让那些容易被忽略的普通时刻，也能够成为未来回忆的一部分。',
                ],
            },
            {
                id: '04',
                title: '人生传记',
                subtitle: '记录每一个人的人生故事',
                image: '',
                paragraphs: [
                    '很多长辈年轻时经历过许多故事，但随着时间推移，后代可能越来越不了解他们的人生。',
                    '人生传记，是族语“动态”的一部分，是为已故亲人打造的一份数字人生档案。它不仅记录一个人的生平经历，更承载着一家人共同保存的回忆。照片、视频、文字、重要经历、人生故事，都可以汇聚在这里，成为一份能够长期留存的人生传记。这不仅是一份记录，更是一份跨越时间的传承，让每一个普通人的一生，都有机会被家人记住。',
                ],
            },
            {
                id: '05',
                title: '时光私信',
                subtitle: '把现在的话留给未来',
                image: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E5%AE%B6%E8%B0%B11080_1920.png',
                paragraphs: [
                    '有些话适合未来再打开。',
                    '族语时光私信，是族语推出的一项未来寄信功能。你可以把今天想说的话提前写下来，选择未来的某一天发送，让这份心意在约定的时间准时抵达。',
                    '例如给未来的孩子、未来的自己，留下现在的想法和祝福。它让数字记录不仅保存过去，也连接未来。',
                ],
            },
            {
                id: '06',
                title: '祈愿祝福',
                subtitle: '保存家庭里的温暖表达',
                image: 'https://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E7%A5%88%E6%84%BF%E6%A0%911080_1920.png',
                paragraphs: [
                    '祈愿树，是族语为每个家庭打造的一棵专属祝福树。',
                    '你可以为自己许愿，也可以为家人祈福，每一份心愿都将挂上枝头。当用户点击“浇水”或为自己许愿、为家人祈福、发布日常动态、为孩子撰写成长动态，以及与家人互动时，祈愿树都会不断成长，见证家庭之间越来越深的情感连接。',
                    '它成长的不只是一棵树，更是一家人共同走过的时光。',
                ],
            },
        ],
    },
}

export default config;



// const config = {
//     lightLogo: 'http://osstest.sayfamily.cn/zuji-web/images/logo/logo/light.png',
//     darkLogo: 'http://osstest.sayfamily.cn/zuji-web/images/logo/logo/dark.png',
//     privacyPolicyUrl: 'http://oss.sayfamily.com/system/appProtocol/privacy-summary.html',
//     userInfoUrl: 'http://oss.sayfamily.com/system/appProtocol/terms-of-service.html',
//     appLogoUrl: 'http://osstest.sayfamily.cn/zuji-web/images/logo/logo/ffffffffff.png',
//     carouselFirst: "http://osstest.sayfamily.cn/zuji-web/images/banner/image5.jpg",
//     carouselSecond: "http://osstest.sayfamily.cn/zuji-web/images/banner/image3.jpg",
//     carouselThird: "http://osstest.sayfamily.cn/zuji-web/images/banner/image4.jpg",
//     appStoreUrl: 'http://apps.apple.com/us/app/族语/id6751788359',
//     androidStoreUrl: 'http//app.mi.com/details?id=com.zuyu.app',
//     downloadQrUrl: '', // 下载二维码图片 URL，留空显示占位
//     jiapuImageUrl: 'http://osstest.sayfamily.cn/zuji-web/images/product/jiapu.png',
//     qiyuanshuImageUrl: 'http://osstest.sayfamily.cn/zuji-web/images/product/qiyuanshu.png',
//     inviteBgUrl: 'http://osstest.sayfamily.cn/zuji-web/images/app/inviteBg.png',
//     andoridIconUrl: 'http://osstest.sayfamily.cn/zuji-web/images/app/androidIcon.png',
//     iosIconUrl: 'http://osstest.sayfamily.cn/zuji-web/images/app/iosIcon.png',
//     rectangleIconUrl: 'http://osstest.sayfamily.cn/zuji-web/images/app/Rectangle.png',
//     introImages: [
//         'http://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E4%BA%BA%E7%94%9F%E7%BB%8F%E5%8E%86%E5%88%97%E8%A1%A81080_1920.png',
//         'http://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E5%AE%B6%E8%B0%B11080_1920.png',
//         'http://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E5%BB%B6%E6%97%B6%E6%B6%88%E6%81%AF1080_1920.png',
//         'http://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E7%A5%88%E6%84%BF%E6%A0%911080_1920.png',
//         'http://oss.sayfamily.com/%E4%BB%8B%E7%BB%8D%E5%9B%BE/%E4%BA%BA%E7%94%9F%E7%BB%8F%E5%8E%86%E8%AF%A6%E6%83%851080_1920.png',

//     ],
//     // 团队成员照片：填入完整 URL，留空则显示占位
//     teamPhotoBaseUrl: 'http://osstest.sayfamily.cn/zuji-web/images/team/',
//     teamPhotos: {
//         '龚志伟': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/gongzhiwei.jpg',
//         '刘一帆': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/liuyifan.jpg',
//         '许鹏晖': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/xupenghui.jpg',
//         '李扬': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/liyang.jpg',
//         '谢振宇': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/xiezhenyu.jpg',
//         '刘安琪': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/liuanqi.jpg',
//         '黄建': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/huangjian.jpg',
//         '程勇辉': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/chengyonghui.jpg',
//         '刘成': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/liucheng.png',
//         '陈君': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/chenjun.jpg',
//         '贺湘': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/hexiangnew.jpg',
//         '涂振武': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/tuzhenwu.jpg',
//         '朱俊飞': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/zhujunfei.jpg',
//         '姚丽婷': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/yaoliting.jpg',
//         '彭永乐': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/pengyongle.jpg',
//         '余光辉': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/yuguanghui.jpg',
//         '岳万林': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/yuewanlin.jpg',
//         '涂招娣': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/tuzhaodi.jpg',
//         '李佩蓉': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/lipeirong.jpg',
//         '张敏': 'http://oss.sayfamily.com/%E4%BA%BA%E5%83%8F%E5%9B%BE/zhangmin.jpg',
//     },
// }

// export default config;